import React, { Component } from 'react';
export default class Contactus extends Component {
  render() {
    return (
      <React.Fragment>
    {/* Contact Section
    ================================================== */}
      <section id="contact">
        <div className="row section-head">
          <p className="lead">Do drop me an email or follow me on linkedIn!
          </p>
        </div>
      </section> {/* Contact Section End*/}

      </React.Fragment>
    );
  }
}
